<template>
  <div>
    <div class="sunshine-port">
      <Crumbs :info="info" :title="navList[0]" />
      <div class="port-container-sales">
        <div class="port-nav">
          <MenuComBToB :navList="navList" />
        </div>
        <div class="port-content">
          <!-- 书写内容区域 -->
          <div class="content-nav">
            <ul class="nav-title">
              <li
                v-for="(item, index) in tabList"
                :key="index"
                :class="[
                  item.isFlex ? 'full-title' : '',
                  idx === index ? 'active-li' : ''
                ]"
                @click="idx = index"
              >
                {{ item.label }}
              </li>
            </ul>
            <div class="content-text">
              <div v-if="idx === 0" class="business-text">
                <dl>
                  <dt><img src="../../../assets/images/BToB/9710.png" alt=""></dt>
                  <dd><p>2020年6月12日，海关总署发布《关于开展跨境电子商务企业对企业出口监管试点的公告》（海关总署公告2020年第75号），增列“9710”（跨境电商B2B直接出口）和“9810”（跨境电商出口海外仓）两个新的海关监管方式。“9710”适用境内企业通过跨境电商平台与境外企业达成交易后，通过跨境物流将货物直接出口送达境外企业；“9810”适用境内企业将出口货物通过跨境物流送达海外仓，通过跨境电商平台实现交易后从海外仓送达购买者；并根据海关要求传输相关电子数据的，按照本公告接受海关监管。</p></dd>
                </dl>
              </div>
              <div v-if="idx === 1" class="advantage-box">
                <p>1.配套完整的资金结算。配套外汇资金收结汇服务， 1.阳光的通关方式。正规、合法的监管模式，促进跨境电商零售进出口阳光化发展。</p>
                <p>2.便利的通关流程。“清单核放”保证通关效率，解决跨境出口订单数量少、批次多的问题。</p>
                <p>3.经济的通关成本。“汇总申报”定期汇总报关，节约通关成本，解决跨境电商出口逐个包裹报关成本高的问题。</p>
                <p>4.便捷的退、免税操作。跨境电商申报信息可作为税务附报内容，支持跨境电商出口企业无忧退、免税。</p>
                <p>依托海关结关数据，快捷回流货款，缓解跨境电商出口企业资金压力。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MenuComBToB from "./common/menuComBToB.vue";
import Crumbs from "../SunShine/common/Crumbs.vue";
import { navList, tabList } from "../../../model/bToB";
export default {
  components: {
    MenuComBToB,
    Crumbs
  },
  data() {
    return {
      info: {},
      navList,
      tabList,
      idx: 0
    };
  },
  created() {
    const path = this.$route.fullPath;
    const index = navList.findIndex(item => item.path === path);
    if (index !== -1) {
      this.info = navList[index];
    }
  }
};
</script>

<style scoped>
.business-text dl{
  display: flex;
  font-size: 18px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #000000;
}
.business-text dl dd{
  margin-left: 10px;
}
.nav-title {
  display: flex;
  height: 50px;
  background: #eef0f4;
  border-radius: 8px 8px 0px 0px;
  line-height: 50px;
  width: 100%;
  border-bottom: 3px solid #D3D3D3;
  margin-bottom: 30px;
}
.nav-title li:hover {
    border-radius: 8px 8px 0px 0px;
    background: #F47310;
    color: #fff;
}
.nav-title .full-title {
  flex: 1;
}
.nav-title li {
  font-size: 22px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  padding-left: 25px;
  padding-right: 10px;
  cursor: pointer;
}
.nav-title .active-li{
  border-radius: 8px 8px 0px 0px;
  background: #F47310;
  color: #fff;
}
.content-nav {
  width: 796px;
  margin: 0 auto;
}
.port-nav {
  margin-right: 42px;
}
.port-container-sales {
  width: 1200px;
  height: 526px;
  margin: 0 auto;
  display: flex;
  padding: 34px 30px;
  border: 1px solid #d3d3d3;
  margin-top: 30px;
  margin-bottom: 186px;
}
.port-content {
  flex: 1;
}
.port-content h2 {
  height: 38px;
  font-size: 30px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  color: #34373b;
  line-height: 38px;
  display: block;
  margin-bottom: 34px;
}
.port-content p {
  font-size: 18px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #000000;
  line-height: 34px;
  margin-bottom: 34px;
}
.advantage-box p{
  text-indent: 0;
  margin: 0;
  font-size: 18px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #000000;
  line-height: 38px;
}



</style>



// WEBPACK FOOTER //
// src/components/children/BToB/Sales.vue